import { Component } from '@angular/core';

@Component({
  selector: 'lib-consult-layout',
  imports: [],
  templateUrl: './consult-layout.html',
  styleUrl: './consult-layout.scss',
})
export class ConsultLayout {}
